/// <reference path="../src/mobile/core/contracts/adhoc.contracts.ts"/>
/// <reference path="../src/mobile/core/contracts/booking.contracts.ts"/>
/// <reference path="../src/mobile/core/contracts/carhire.contracts.ts"/>
/// <reference path="../src/mobile/core/contracts/flights.contracts.ts"/>
/// <reference path="../src/mobile/core/services/adhoc.service.ts"/>
/// <reference path="../src/mobile/core/services/arrayUtils.service.ts"/>
/// <reference path="../src/mobile/core/services/basketCrossSell.service.ts"/>
/// <reference path="../src/mobile/core/services/broker.service.ts"/>
/// <reference path="../src/mobile/core/services/fieldGroup.service.ts"/>
/// <reference path="../src/mobile/core/services/flightDetail.service.ts"/>
/// <reference path="../src/mobile/core/services/flightsTerminal.service.ts"/>
/// <reference path="../src/mobile/core/services/guid.service.ts"/>
/// <reference path="../src/mobile/core/services/language.service.ts"/>
/// <reference path="../src/mobile/core/services/logging.service.ts"/>
/// <reference path="../src/mobile/core/services/pagingService.ts"/>
/// <reference path="../src/mobile/core/services/paymentsUtil.service.ts"/>
/// <reference path="../src/mobile/core/services/occupancy.service.ts"/>
/// <reference path="../src/mobile/core/services/resource.service.ts"/>
/// <reference path="../src/mobile/core/services/rootPath.service.ts"/>
/// <reference path="../src/mobile/trp/services/animationUtils.service.ts"/>
/// <reference path="../src/mobile/trp/services/componentUtils.service.ts"/>
/// <reference path="../src/mobile/trp/services/discounts.service.ts"/>
/// <reference path="../src/mobile/trp/services/flightStatic.service.ts"/>
/// <reference path="../src/mobile/trp/services/globalisation.service.ts"/>
/// <reference path="../src/mobile/trp/services/location.service.ts"/>
/// <reference path="../src/mobile/trp/services/tokeniser.service.ts"/>
/// <reference path="../src/mobile/deepLink/deepLinkInterfaces.ts"/>

import generateRange from './filters/generateRange';
import occupancyFilter from './filters/occupancy';
import replaceLineBreaks from './filters/replaceLineBreaks';
import resourceFilter from './filters/resourceFilter';
import * as adHoc from './services/adHoc';
import * as arrayUtils from './services/arrayUtils';
import * as basketCrossSell from './services/basketCrossSell';
import * as broker from './services/broker';
import * as cookieService from './services/cookie';
import * as currentUser from './services/currentUser';
import decimalAdjust from './services/decimalAdjust';
import * as enumService from './services/enum';
import * as fieldFilterParser from './services/fieldFilterParser';
import * as fieldGroup from './services/fieldGroup';
import * as flightDetail from './services/flightDetail';
import * as flightsTerminal from './services/flightsTerminal';
import * as guid from './services/guid';
import * as imageService from './services/image';
import * as language from './services/language';
import * as loader from './services/loader';
import * as logging from './services/logging';
import * as modal from './services/modal';
import * as occupancy from './services/occupancy';
import * as paging from './services/paging';
import * as paymentsUtil from './services/paymentsUtil';
import * as resource from './services/resource';
import * as rootPath from './services/rootPath';
import * as supportedProducts from './services/supportedProducts';
import * as urlUtils from './services/urlUtils';

import frontPad from './filters/frontPad';
import hoursAndMinutes from './filters/hoursAndMinutes';
import replace from './filters/replace';
import toText from './filters/toText';
import * as abTest from './services/abTest';
import * as agentModeService from './services/agentMode';
import * as animationUtils from './services/animationUtils';
import * as componentUtils from './services/componentUtils';
import * as bookingStatus from './services/bookingStatus';
import * as cmsService from './services/cms';
import * as currency from './services/currency';
import * as destinationAirport from './services/destinationAirport';
import * as discountsService from './services/discounts';
import * as extraProductsService from './services/extraProducts';
import filterUtil from './services/filterUtil';
import * as flightSeatPlanService from './services/flightSeatPlan';
import * as flightStaticService from './services/flightStatic';
import getPropertyTypeFromResKey from './services/getPropertyTypeResKey';
import * as globalisationService from './services/globalisation';
import * as googleStaticMap from './services/googleStaticMap';
import * as hotelFilterQueryStringParser from './services/hotelFilterQueryStringParser';
import * as hotelsFilter from './services/hotelsFilter';
import * as location from './services/location';
import * as objectTypeService from './services/objectType';
import * as optionsUtil from './services/optionsUtils';
import * as paymentsCalculator from './services/paymentsCalculator';
import * as postcodeService from './services/postcode';
import * as preferencesHttpProvider from './services/preferencesHttpProvider';
import * as primaryNavigationService from './services/primaryNavigation';
import * as publicityService from './services/publicityMessaging';
import * as regExpRoutes from './services/regExpRoutes';
import * as searchTypesService from './services/searchTypes.js';
import * as scrollService from './services/scroller';
import scrollTo from './services/scrollTo';
import * as tokeniser from './services/tokeniser';
import * as urgencyMessaging from './services/urgencyMessaging';
import * as validationService from './services/validation';
import * as windowUtil from './services/windowUtil';
import './services/deepLinkService';

import * as productService from './components/products/services/products';

angular
    .module('core')
    .filter('generateRange', () => generateRange)
    .filter('occupancy', () => occupancyFilter)
    .filter('replaceLineBreaks', () => replaceLineBreaks)
    .filter('resource', () => resourceFilter)
    .filter('unformattedString', () => String.format)
    .service('adHocService', (): Core.AdHoc.AdHocService => adHoc)
    .factory('arrayUtil', (): Core.ArrayUtil => arrayUtils)
    .service('basketCrossSellService', (): Core.BasketCrossSellService => basketCrossSell)
    .factory('broker', (): Core.Broker => broker)
    .factory('cookieService', () => cookieService)
    .factory('currentUser', () => currentUser)
    .factory('decimalAdjust', () => decimalAdjust)
    .service('enumService', () => enumService)
    .factory('fieldFilterParser', () => fieldFilterParser)
    .service('fieldGroupService', (): Core.FieldGroupService => fieldGroup)
    .service('flightDetail', (): Core.Flights.IFlightDetailService => flightDetail)
    .service('flightsTerminalService', (): Core.FlightsTerminalService => flightsTerminal)
    .service('guidService', (): Core.GuidService => guid)
    .factory('imageService', () => imageService)
    .service('languageService', (): Core.LanguageService => language)
    .factory('loaderService', () => loader)
    .service('loggingService', (): Core.ILoggingService => logging)
    .factory('modalService', () => modal)
    .service('occupancyService', (): Core.OccupancyService => occupancy)
    .service('pagingService', (): Core.PagingService => paging)
    .service('paymentsUtilService', (): Core.PaymentsUtilService => paymentsUtil)
    .service('resourceService', (): Core.ResourceService => resource)
    .service('rootPath', (): Core.RootPath => rootPath)
    .service('supportedProducts', () => supportedProducts)
    .factory('urlUtils', () => urlUtils);

angular
    .module('TR')
    .filter('frontPad', () => frontPad)
    .filter('hoursAndMinutes', () => hoursAndMinutes)
    .filter('replace', () => replace)
    .filter('toText', () => toText)
    .service('abTest', () => abTest)
    .factory('agentModeService', () => agentModeService)
    .service('animationUtil', (): TR.AnimationUtil => animationUtils)
    .service('componentUtil', (): TR.ComponentUtil => componentUtils)
    .service('bookingStatus', () => bookingStatus)
    .service('cmsService', () => cmsService)
    .service('currencyService', () => currency)
    .service('destinationAirport', () => destinationAirport)
    .service('discountsService', (): TR.DiscountsService => discountsService)
    .service('extraProductsService', () => extraProductsService)
    .service('FilterUtils', () => filterUtil)
    .service('flightSeatPlanService', () => flightSeatPlanService)
    .service('flightStaticService', (): TR.FlightStaticService => flightStaticService)
    .factory('getPropertyTypeFromResKey', () => getPropertyTypeFromResKey)
    .service('globalisationService', (): TR.IGlobalisationService => globalisationService)
    .service('googleStaticMap', () => googleStaticMap)
    .service('hotelFilterQueryStringParser', () => hotelFilterQueryStringParser)
    .service('hotelsFilter', () => hotelsFilter)
    .service('locationService', (): TR.LocationService => location)
    .service('objectTypeService', () => objectTypeService)
    .service('optionsUtil', () => optionsUtil)
    .service('paymentsCalculator', () => paymentsCalculator)
    .service('postcodeService', () => postcodeService)
    .service('preferencesHttpProvider', () => preferencesHttpProvider)
    .service('primaryNavigationService', () => primaryNavigationService)
    .service('publicityService', () => publicityService)
    .service('regExpRoutes', () => regExpRoutes)
    .service('scrollService', () => scrollService)
    .factory('scrollTo', () => scrollTo)
    .service('searchTypesService', () => searchTypesService)
    .service('tokeniser', (): TR.TokeniserService => tokeniser)
    .service('urgencyMessaging', () => urgencyMessaging)
    .service('validationService', () => validationService)
    .service('windowUtil', () => windowUtil)
    .service('productService', () => productService);

